import { API } from "../api/builder";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../context/ConfigProvider";
import { AuthSession } from "../typings/interfaces/Configuration/AuthSession";
import { notify } from "../utils/Notify";
import { NotifyType } from "../utils/NotifyType";
import { AccessToken } from "../typings/interfaces/Configuration/accessToken";
import { AuthParam } from "../typings/interfaces/Configuration/AuthParam";
import { ApiUrl,PageUrl, SessionKey } from "../utils/app-config";
import { errorLogging } from "../utils/errorLogging";

export const useAuthService = () => {
    const navigate = useNavigate();  
    const cfg = useConfig();
    const SERVER_URL = cfg.REACT_APP_API_BASE_URL;
  // Use central API instance; it injects `x-api-key` and `Authorization` via interceptors
  const token = localStorage.getItem(SessionKey.AuthToken) ?? '';
  const { handleHttpError } = errorLogging();
  const { message } = notify();


  const getAuthSettings = async (url:string): Promise<AuthParam | null> => {
    let response: AxiosResponse<AuthParam> | void;
    response = await API.get(`${SERVER_URL}${url}`).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "OIDC Configurations Loading Failed")
        return null;
    }
}

const getDiscoveryEndpoint = async (url:string): Promise<AuthParam | null> => {
    let response: AxiosResponse<any> | void;
    response = await API.get(`${SERVER_URL}${url}`).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Login discovery endpoint was Failed")
        return null;
    }
}

const createSession = async (userType:string,loginType: string): Promise<AccessToken | null> => {
    let response: AxiosResponse<any> | void;
    let sessionData={
        userLoginType:loginType,
        userType:userType
    }
    response = await API.post(`${SERVER_URL}${ApiUrl.CreateUserSession}`,sessionData).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Error in creating a new login session")
        return null;
    }
}

const getSPToken = async (code:string,state: string): Promise<AccessToken | null> => {
    let response: AxiosResponse<AccessToken> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.Token}?authCode=${code}&state=${state}`).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Error in user authentication")
        return null;
    }
}

const getCPToken = async (code:string,state: string): Promise<any | null> => {
    let response: AxiosResponse<any> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.CPToken}?authCode=${code}&state=${state}`).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Error in user authentication")
        return null;
    }
}

const createLoginSession = async (sessionData:any,url:string): Promise<AuthSession | null> => {
    let response: AxiosResponse<any> | void;       
    response = await API.post(`${SERVER_URL}${url}`,sessionData).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Error in creating a new login session")
        return null;
    }
}

const getToken = async (tokenRequest:any,tokenUrl:string): Promise<any | null> => {
    let response: AxiosResponse<any> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.MyInfoToken}`,tokenRequest).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        message(NotifyType.Info, "Error in user authentication")
        return null;
    }
}

const logout =  async () => {       
    localStorage.clear();
    window.location.href = '/eservices/';
    {/*let response: AxiosResponse<any> | void;
    response = await axios.post(`${SERVER_URL}${ApiUrl.LogoutSession}`,null,  {
        headers: authheaders
    }).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        
        navigate(PageUrl.HomeEservices);
    } else {
        message(NotifyType.Info, "Error in creating a new login session")
        return null;
    }*/}
    
}

const getAuthToken = async () => {
    if(localStorage.getItem(SessionKey.AuthToken) !== '' && localStorage.getItem(SessionKey.AuthToken) !== null)
    {
        return true;
    }
    return null;
    {/*if (localStorage.getItem(SessionKey.AuthToken) !== '' && localStorage.getItem(SessionKey.AuthToken) !== null)
    {
        let response: AxiosResponse<any> | void;
        let token = localStorage.getItem(SessionKey.AuthToken);
            response = await API.post(`${SERVER_URL}${ApiUrl.ValidateUserToken}?token=${token}`).catch(err => { handleHttpError(err, false) });
        if (response && response.status === 200) {
            if(response.data)
            {
                return "true";
            }
            return null;
           
        } else {
            const itemStr = localStorage.getItem(SessionKey.AuthToken);

        // If the item doesn't exist, return null
        if (itemStr) {
            localStorage.removeItem(SessionKey.AuthToken);
        }
        message(NotifyType.Info, "token expired")
        return null;
        }
    }
    return null;*/}
}

  const getSPJwk = async (): Promise<any | null> => {
    let response: AxiosResponse<any> | void;
        response = await API.get<any>(`${SERVER_URL}${ApiUrl.SPJwk}`).catch(err => { handleHttpError(err, false) });

    if (response && response.status === 200) {
      return response.data;
    } else {
      message(NotifyType.Info, "Error in user authentication");
      return null;
    }
  }

  const getCPJwk = async (): Promise<any | null> => {
    let response: AxiosResponse<any> | void;
        response = await API.get<any>(`${SERVER_URL}${ApiUrl.CPJwk}`).catch(err => { handleHttpError(err, false) });

    if (response && response.status === 200) {
      return response.data;
    } else {
      message(NotifyType.Info, "Error in user authentication");
      return null;
    }
  }

  return {
    logout,
    getAuthSettings ,
    getSPToken,
    getCPToken,
    getDiscoveryEndpoint,
    createSession,        
    createLoginSession,
    getToken,
    getSPJwk,
    getCPJwk,
    getAuthToken
  }
 }





